module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about-us"
  }, [_c('div', {
    staticClass: "about-us-wrap"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": require("../../static/images/usbj2.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "page-caption"
  }, [_c('h1', {
    staticClass: "anders"
  })]), _vm._v(" "), _c('div', {
    staticClass: "page-caption"
  }, [_c('div', {
    staticClass: "point"
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ff1b834"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/AboutUs.vue
// module id = 994
// module chunks = 1